<template>
  <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="银行卡名称" prop="bankName">
        <el-input id="bankName" v-model="form.bankName" placeholder="请输入银行卡名称" />
      </el-form-item>
      <el-form-item label="借编码" prop="borrowCode">
        <el-input id="borrowCode" v-model="form.borrowCode" placeholder="请输入借编码" />
      </el-form-item>
      <el-form-item label="贷编码" prop="loanCode">
        <el-input id="loanCode" v-model="form.loanCode" placeholder="请输入贷编码" />
      </el-form-item>
      <el-form-item label="城市公司" prop="cityId" class="width100">
        <el-select id="cityId" v-model="form.cityId" placeholder="请选择城市公司" filterable size="small" clearable>
          <el-option v-for="item in cityCompanyOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="isEnable">
        <el-switch id="isEnable" v-model="form.isEnable" active-value="1" inactive-value="0"></el-switch>{{form.isEnable?'启用':'禁用'}}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysDataconstantApi from '@/api/config/sysDataconstant'
import cityCompanyApi from '@/api/sys/cityCompany'
function initFormBean() {
  const formBean = {
    id: null,
    bankName: null,
    borrowCode: null,
    loanCode: null,
    isEnable: '1',
    cityId: null,
    cityName: null
  }
  return formBean
}

function assignBankIds(list = []) {
  return list.map((item, index) => ({
    ...item,
    id: index + 1
  }))
}

function normalizeBankName(bankName) {
  return (bankName || '').replace(/\s+/g, '')
}

export default {
  props: ['rowItem'],
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      cityCompanyOptions: [],
      formRules: {
        bankName: [{ required: true, message: '请输入银行卡名称', trigger: 'blur' }],
        borrowCode: [{ required: true, message: '请输入借编码', trigger: 'blur' }],
        loanCode: [{ required: true, message: '请输入贷编码', trigger: 'blur' }],
        isEnable: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false,
      isAdd: 1, // 1 新增 0 编辑
      oldBankName: null,
      oldForm: null
    }
  },
  created() {
    this.getCityCompany()
  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.isRepSub = false
      this.isAdd = 1
      this.form = initFormBean()
      this.oldForm = null
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.isAdd = 1
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(scope) {
      this.resetForm()
      this.isAdd = 0
      this.form = { ...scope.row }
      this.oldBankName = scope.row.bankName
      this.oldForm = { ...scope.row, id: Number(scope.row.id) || scope.row.id }
      
      // 优先使用cityId，如果没有则处理cityIds（兼容旧数据）
      // 确保转换为数字类型，因为城市公司接口返回的id是数字
      // 如果没有cityId和cityIds，设置为null，允许用户重新选择（按新增流程）
      if (scope.row.cityId !== null && scope.row.cityId !== undefined && scope.row.cityId !== '') {
        // 转换为数字，确保类型匹配（与下拉选项的value类型一致）
        const cityIdNum = Number(scope.row.cityId)
        this.form.cityId = isNaN(cityIdNum) ? null : cityIdNum
      } else if (scope.row.cityIds) {
        const cityIdStr = scope.row.cityIds.replaceAll('#', '')
        if (cityIdStr) {
          const cityIdNum = Number(cityIdStr)
          this.form.cityId = isNaN(cityIdNum) ? null : cityIdNum
        } else {
          this.form.cityId = null
        }
      } else {
        // 如果没有cityId和cityIds，设置为null，用户可以重新选择
        this.form.cityId = null
      }
      
      // 如果数据中有cityName，也保留；如果没有，会在保存时根据选中的cityId自动获取
      if (scope.row.cityName) {
        this.form.cityName = scope.row.cityName
      } else {
        this.form.cityName = null
      }
      
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      let { content } = this.rowItem;
      let list = content ? JSON.parse(content) : []
      list = assignBankIds(list)
      const currentBankName = normalizeBankName(this.form.bankName)
      const currentId = this.isAdd ? null : Number(this.oldForm.id)
      const isDuplicate = list.some(item => {
        const sameName = normalizeBankName(item.bankName) === currentBankName
        const isCurrentItem = !this.isAdd && Number(item.id) === currentId
        return sameName && !isCurrentItem
      })

      if (isDuplicate) {
        this.$message.error('银行卡名称不能重复');
        return;
      }
      
      // 根据选中的城市公司ID获取城市公司名称（新增和编辑都需要处理）
      let cityId = this.form.cityId
      let cityName = ''
      if (cityId !== null && cityId !== undefined && cityId !== '') {
        const selectedCityCompany = this.cityCompanyOptions.find(item => item.id === cityId);
        cityName = selectedCityCompany ? selectedCityCompany.name : ''
      }
      
      const formData = {
        ...this.form,
        bankName: (this.form.bankName || '').trim(),
        id: this.isAdd ? list.length + 1 : this.oldForm.id,
        cityId: cityId,
        cityName: cityName
      }
      
      if (this.isAdd) {
        list.push(formData)
      } else {
        const realIndex = list.findIndex(item => Number(item.id) === Number(this.oldForm.id))
        if (realIndex === -1) {
          this.$message.error('未找到原始数据，请刷新页面后重试')
          return
        }
        list[realIndex] = formData
      }
      list = assignBankIds(list)
      let params = JSON.parse(JSON.stringify(this.rowItem))
      params.content = JSON.stringify(list)
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          sysDataconstantApi.update(params).then((data) => {
            this.postCallback(data)
          }).catch(res => {
            this.isRepSub = false
          });
        }
      });
    },
    postCallback(response) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
    //获取城市公司
    getCityCompany() {
      cityCompanyApi.fetchList({ pageNo: 1, pageSize: 1000, state: 1 }).then(res => {
        this.cityCompanyOptions = res.data.list || []
      }).catch(err => {
        console.error('获取城市公司列表失败:', err)
        this.cityCompanyOptions = []
      })
    },
  }
}
</script>
